import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import Image from '../global/Image';

export default class PageTextCarousel extends Component {
    
    constructor(){
		super()
		this.state = {
			open:false,
		}
		this.handleToggle = this.handleToggle.bind(this);
	}
    
    handleToggle(_el) {  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    	setTimeout(() => {
				window.dispatchEvent(new Event('resize'));
			}, 800);
	    } else {
		    this.setState({ open : true });
		    setTimeout(() => {
				window.dispatchEvent(new Event('resize'));
			}, 800);
	    }
    }
    
	render () {
		
		let block 	= this.props.block;
		
		if (block) {
			
			const settings = {
				dots: true,
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 2400,
			};
			let slides = null;
			let dots = null;
			
			slides = block.gallery.map((image,i) =>
				<div key={i}>
					<Image src={image.src} srcset={image.srcset}></Image>
				</div>
			);
			dots = block.gallery.map((image,i) =>
				<a href="#" key={i}></a>
			);
			
			let accordionText = 'Read More';
			if (this.state.open === true) {
				accordionText = 'Read Less';
			}
			
		    return (
		        
		        <div id={block.id} className={'c-page__block c-page__block--' + block.background_colour}>
		        	
		        	<div className="c-text-carousel">
		        	
		        		<div className="l-grid c-text-carousel__inner">
		        		
		        			<div className="l-grid__col l-grid__col--l-6-12 l-grid__col--l-push-6-12">
		        			
		        				<header className="c-text-carousel__header u-l-hide">
		        					<h1 className="c-heading">
		        						<span className="c-heading__line">
		        							<span className="c-heading__line__inner" dangerouslySetInnerHTML={{ __html:block.heading }}></span>
		        						</span>
		        					</h1>
		        				</header>
		        				
		        				{block.introduction &&
		        					<div className="c-text-carousel__intro scope-large-text c-load-fade" dangerouslySetInnerHTML={{ __html:block.introduction }}></div>
		        				}
		        				
		        				<div className="c-text-carousel__text">
			        				<div className="scope-text c-load-fade" dangerouslySetInnerHTML={{ __html:block.text }}></div>			        				
			        				{block.read_more_text &&
				        				<div className={`c-accordion c-load-fade ${this.state.open ? "state-open" : ""}`}>
											
											<div className="c-accordion__body">
												<div className="c-accordion__body-inner">
													<div className="scope-text" dangerouslySetInnerHTML={{__html:block.read_more_text}}></div>
												</div>
											</div>
											<a href="#" className="c-accordion__header" onClick={(e) => (e.preventDefault(), this.handleToggle(e.currentTarget))}>{ accordionText }</a>
										</div>
									}
		        				</div>
		        				
		        			</div>
		        			
		        			<div className="l-grid__col l-grid__col--l-6-12">
		        			
		        				<header className="c-text-carousel__header u-l-show">
		        					<h1 className="c-heading">
		        						<span className="c-heading__line">
		        							<span className="c-heading__line__inner" dangerouslySetInnerHTML={{ __html:block.heading }}></span>
		        						</span>
		        					</h1>
		        				</header>
		        				
		        			</div>
		        			
		        			<div className="l-grid__col l-grid__col--l-6-12">
		        				<div className={'scope-slick'}>
				    				<Slider {...settings}>
				    					{ slides }
									</Slider>
								</div>
		        			</div>
		        			
		        		</div>
		        		
		        		{block.cta_link_text && block.cta_link_url &&
			        		<Link to={{ pathname: block.cta_link_url }} className="c-text-carousel__link c-load-fade" dangerouslySetInnerHTML={{__html:block.cta_link_text}}></Link>
		        		}
		        		
		        	</div>
		        	
		        </div>      	
			        	
			)
			
		} else {
			
			return null;
		
		}
	}
}
